import { OrigemBudgetPlanilha, PlanilhaOrdemJob, PlanilhaCompraTipo, } from '../generated/backend-enums.js';
export { OrigemBudgetPlanilha, PlanilhaOrdemJob, PlanilhaCompraTipo };
export const OrigemBudgetPlanilhaMap = {
    [OrigemBudgetPlanilha.DEFINIDO_PELO_CLIENTE]: 'Definido pelo Cliente',
    [OrigemBudgetPlanilha.ESTIMATIVA_INICIAL]: 'Estimativa Inicial',
};
export const PlanilhaOrdemJobMap = {
    [PlanilhaOrdemJob.PRINCIPAL]: 'Principal',
    [PlanilhaOrdemJob.JOB_NOVO]: 'Job Novo',
    [PlanilhaOrdemJob.COMPLEMENTAR]: 'Complementar',
};
export const PlanilhaOrdemJobTooltipMap = {
    [PlanilhaOrdemJob.PRINCIPAL]: 'Primeira planilha do Job, já com pré-produção definida.',
    [PlanilhaOrdemJob.JOB_NOVO]: 'Primeira planilha do Job, ainda sem pré-produção definida.',
    [PlanilhaOrdemJob.COMPLEMENTAR]: 'Esta planilha foi vinculada posteriormente ao mesmo Job.',
};
export const PlanilhaCompraTipoMap = {
    [PlanilhaCompraTipo.NOVA]: 'Nova',
    [PlanilhaCompraTipo.ATRIBUIDA]: 'Atribuída',
    [PlanilhaCompraTipo.SEM_OPORTUNIDADE]: 'Sem Oportunidade',
};
export const PlanilhaCompraTipoTooltipMap = {
    [PlanilhaCompraTipo.NOVA]: 'Ainda sem comprador vinculado — disponível para Compras agir.',
    [PlanilhaCompraTipo.ATRIBUIDA]: 'Já possui um comprador ativo alocado.',
    [PlanilhaCompraTipo.SEM_OPORTUNIDADE]: 'Comprador concluiu que não há atuação. Sem ações disponíveis.',
};
